import React, { Component } from "react";
import { getMisc, getPassPercent } from "../../../../localstorage-service";
// import * as constants from "../../../../constants";

import Aux from "../../../../hoc/Auxilliary";
import Question from "../../Learning/Assignment/Question/Question";
import { getBrightcoveAccountId } from "../../../../localstorage-service";

class AssessmentResult extends Component {
  answerClicked(id) {
    this.props.answerClicked(id);
  }
  render() {
    // console.log("percent scored");
    // console.log(this.props.percentScored);
    // console.log(getPassPercent());

    return (
      <Aux>
        {parseInt(this.props.percentScored, 10) >=
          parseInt(getPassPercent(), 10) && (
          <div className="alert alert-success">
            <strong>{getMisc("welldone")}!</strong> {getMisc("youscored")}{" "}
            {this.props.percentScored}% {getMisc("passmessage")}
          </div>
        )}
        {parseInt(this.props.percentScored, 10) <
          parseInt(getPassPercent(), 10) && (
          <div className="alert alert-danger">
            <strong>{getMisc("ohsnap")}!</strong> {getMisc("youscored")}{" "}
            {this.props.percentScored}% {getMisc("failmessage")}
          </div>
        )}
        {this.props.questions.map((question, index) => {
          return (
            <Question
              index={index + 1}
              totalquestions={this.props.questions.length}
              key={question.Id}
              questionId={question.Id}
              videoId={question.VideoId}
              subCategoryId={question.SubCategoryId}
              questionTypeId={question.QuestionTypeId}
              questionText={question.QuestionText}
              videoName={question.VideoName}
              videoCategoryName={question.VideoCategoryName}
              answers={question.answers}
              isAssessmentSubmitted={this.props.isAssessmentSubmitted}
              answerClicked={id => this.answerClicked(id)}
              brightcoveVideoId={question.BrightcoveVideoId}
              brightcoveAccountId={getBrightcoveAccountId()}
            />
          );
        })}
      </Aux>
    );
  }
}

export default AssessmentResult;



// WEBPACK FOOTER //
// ./src/containers/User/Common/VideoMain/AssessmentResult.js